/**
 * User activity types for recommendation interactions
 */
export enum UserActivityType {
  LIKED = 'liked',
  DISLIKED = 'disliked',
  NEUTRAL_RATING = 'neutral_rating',  // Used on the onboarding flow, to let users specify neutrality regards a given recommendation
  SCROLLED_PAST = 'scrolled_past_without_interaction',
  INTERACTED = 'interacted',
  BOOKMARKED = 'bookmarked',
}

/**
 * Resource types for recommendation items
 */
export enum ResourceType {
  YT_SHARP = 'yt_sharp',
  YT_FULL_VIDEO = 'yt_full_video',
}
